<template>
  <div class="baseContent-warp">
    <Card>
      <span slot="title">取号退号</span>
      <el-button slot="btn" icon="el-icon-refresh" @click="$refresh([getRegistersList, getStatusNumber])"
        class="fr">刷新</el-button>
      <div slot="content" class="wrap">
        <!-- 条件查询 -->
        <el-form class="search" inline :model="searchForm">
          <el-form-item label="患者">
            <el-input v-model="searchForm.patientName" placeholder="请输入患者姓名" />
          </el-form-item>
          <el-form-item label="手机">
            <el-input v-model="searchForm.phone" placeholder="请输入患者手机号" />
          </el-form-item>
          <el-form-item label="渠道">
            <el-select v-model="searchForm.channel" placeholder="请选择挂号渠道">
              <el-option v-for="item in options" :key="item" :label="item + '挂号'" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="医生">
            <el-select allow-create clearable v-model="searchForm.doctorName" placeholder="请选择医生" filterable
              default-first-option>
              <el-option v-for="item in doctorOptions" :key="item.value" :label="item.label" :value="item.label">
                <span class="fl">{{ item.label }}</span>
                <span class="select-flex">{{ item.phone }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker v-model="searchForm.time" value-format="yyyy-MM-dd" type="date" placeholder="请选择就诊日期"
              @change="$refresh([getRegistersList, getStatusNumber], true)" />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary"
              @click="$refresh([getRegistersList, getStatusNumber], true)">查询</el-button>
            <el-button icon="el-icon-refresh"
              @click="$reset(getRegistersList, { patientName: null, doctorName: null, phone: null, channel: null, time: null, status: searchForm.status })">重置</el-button>
          </el-form-item>
        </el-form>
        <!-- 状态菜单 -->
        <el-tabs v-model="activeIndex" mode="horizontal" @tab-click="changeStatus">
          <el-tab-pane v-for="item in menuList" :key="item.value" :label="item.label + '(' + item.number + ')'"
            :name="item.value" />
        </el-tabs>
        <div>
          <!-- 挂号列表 -->
          <el-table v-loading="loading" :data="regList" :max-height="tableHeight" border>
            <el-table-column type="index" label="序号" width="50" fixed="left" />
            <el-table-column prop="patientName" label="患者姓名" min-width="100" fixed="left" />
            <el-table-column prop="sex" label="性别" />
            <el-table-column prop="phone" label="手机号" min-width="120" />
            <el-table-column prop="orderNumber" label="订单号" min-width="220" />
            <el-table-column prop="status" label="状态" min-width="100" />
            <el-table-column prop="price" label="挂号费/元" min-width="100" />
            <el-table-column prop="payWay" label="支付方式" min-width="80" :formatter="payWayFormatter" />
            <el-table-column prop="doctorName" label="预约医生" min-width="80" />
            <el-table-column prop="deptName" label="预约医馆" v-if="!deptId" min-width="80" />
            <el-table-column prop="schedulingTime" label="就诊日期" min-width="100" />
            <el-table-column prop="timeName" label="班次及排序" min-width="100" />
            <el-table-column prop="startTime" label="预计就诊时间" min-width="110" />
            <el-table-column prop="channel" label="支付途径" min-width="80" />
            <el-table-column label="操作" width="260" v-if="deptId" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary" @click="toCharge(scope.row)" v-if="scope.row.status == '待支付'"
                  icon="el-icon-circle-check">收费</el-button>
                <el-button @click="toPrint(scope.row)"
                  v-if="scope.row.status != '已退号' && scope.row.status != '已退款' && scope.row.status != '待支付'"
                  icon="el-icon-printer">打印</el-button>
                <el-button type="success" @click="sign(scope.row)" v-if="scope.row.status == '待签到'"
                  icon="el-icon-check">签到</el-button>
                <el-button type="danger" @click="returnNum(scope.row.registeredId)" v-if="scope.row.status == '待支付' || scope.row.type=='5'"
                  icon="el-icon-close">退号</el-button>
                <el-button type="danger" @click="toRefund(scope.row)"
                  v-if="(scope.row.status == '待签到' || scope.row.status == '待就诊' || scope.row.status == '停诊') &&  scope.row.type !== '5'" 
                  icon="el-icon-circle-close">退款</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination class="mt20" @current-change="page => $handleCurrentChange(page, getRegistersList)"
            :total="total" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
        </div>
        <!-- 收费模态框 -->
        <el-dialog v-loading="payLoading" width="400px" title="收费" :visible.sync="dialogVisible" append-to-body
          :before-close="$handleClose" :close-on-click-modal="false">
          <div class="charge">￥{{ payForm.price }}</div>
          <el-button v-for="item in payArr" :key="item" type="primary" :disabled="item == ('医保卡' || '代金券') ? true : false"
            class="chargeBtn" @click="payWay(item)" plain>{{ item }}</el-button>
          <el-input @change="getCode" v-model="payForm.payQrCode" class="hide-section" ref="codeInput"></el-input>
          <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="$cancel('dialogVisible', 'payForm')">关闭</el-button>
            <el-button size="mini" type="primary" @click="charge">完成收费</el-button>
          </span>
        </el-dialog>
        <!-- 好码齐 -->
        <el-dialog width="350px" title="" :show-close="false" :visible.sync="codeVisible" append-to-body
          :before-close="done => $handleClose(done, 'codeForm')" :close-on-click-modal="false">
          <section class="load_content">
            <el-image class="load_section" :src="loadingImg"></el-image>
            <section class=" size18 flex marginT30 center jc_ce al_ce">
              <label>扫顾客二维码</label>
              <label class="flex al_ce load jc_ce marginL5">
                <div class="circle marginR5"></div>
                <div class="circle marginR5"></div>
                <div class="circle marginR5"></div>
              </label>
            </section>
          </section>
        </el-dialog>
        <!-- 小票模态框 -->
        <el-dialog title="打印挂号单" :visible.sync="dialogPrint" :before-close="$handleClose" width="300px" :close-on-click-modal="false">
          <div id="printMsg">
            <div style="width: 260px; font-size: 16px; line-height: 22px; margin: 3px 0; color: #000;">
              <div style="line-height: 30px; font-size: 22px; text-align: center; letter-spacing: 2px;">{{
                printData.deptName }}</div>
              <div
                style="line-height: 20px; font-size: 18px; text-align: center; letter-spacing: 2px; margin-bottom: 20px;">
                挂号单</div>
              <p>姓名：
                <span style="margin-right: 10px;">{{ printData.patientName }}</span>
                <span style="margin-right: 10px;">{{ printData.sex == 0 ? "男" : "女" }}</span>
                <span>
                  {{ printData.year }}岁
                  <span v-if="printData.year < 10 && printData.month > 0">{{ printData.month }}月</span>
                </span>
              </p>
              <p>电话：{{ printData.patientPhone }}</p>
              <p>医生：{{ printData.doctorName }}</p>
              <p style="margin: 5px 0 10px;">序号：<b style="font-size: 18px;">{{ printData.code }}</b></p>
              <div style="height: 0; margin: 5px 0; border-bottom: 1px #ccc dashed;"></div>
              <p>就诊日期：{{ printData.schedulingTime }}</p>
              <p>就诊时间：{{ printData.startTime }}-{{ printData.stopTime }}</p>
              <p>就诊诊室：{{ printData.clinicName }}</p>
              <p>就诊类型：{{ printData.type }}门诊</p>
              <div style="height: 0; margin: 5px 0; border-bottom: 1px #ccc dashed;"></div>
              <p>金额：{{ formatNumber(printData.price) }} 元</p>
              <p>实付：{{ formatNumber(printData.realPay) }} 元</p>
              <div style="height: 0; margin: 5px 0; border-bottom: 1px #ccc dashed;"></div>
              <p v-if="printData.isReceipts == '多次'">打印次数：{{ printData.isReceipts }}</p>
              <!-- <p>操作员：{{ printData.createBy }}</p> -->
              <p v-if="printData.createTime">预约日期：{{ printData.createTime.substr(0, 10) }}</p>
              <p>电话：{{ printData.phone }}</p>
              <p>地址：{{ printData.address }}</p>
              <div style="margin-top: 20px; text-align: center;">
                <!-- <img :src="'data:image/gif;base64,' + printData.img" width="200"> -->
                <div>当诊有效 过期作废</div>
              </div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="print">打印</el-button>
            <el-button @click="$cancel('dialogPrint')">取 消</el-button>
          </span>
        </el-dialog>
        <!-- 退款模态框 -->
        <el-dialog title="退号退款" :visible.sync="dialogRefund" :before-close="$handleClose" width="400px" :close-on-click-modal="false">
          <div class="price">￥{{ refundForm.refundAmount }}</div>
          <el-form :model="refundForm" ref="refundForm" label-width="80px" inline>
            <el-form-item label="退款方式" prop="refundWayStr"
              :rules="[{ required: true, message: '请选择退款方式！', trigger: 'change' }]">
              <el-radio-group v-model="refundForm.refundWayStr" disabled>
                <el-radio :label="'原路返回'" />
                <el-radio :label="'直接退现金'" />
              </el-radio-group>
            </el-form-item>
            <el-form-item label="添加备注">
              <el-input placeholder="请输入备注" v-model="refundForm.remark" />
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button :loading="refundLoading" @click="isRefund" type="danger">退款</el-button>
            <el-button :loading="refundLoading" @click="$cancel('dialogRefund', 'refundForm')">取 消</el-button>
          </span>
        </el-dialog>
        <!-- 打印 -->
        <printDialog v-if="printDialogShow" @closePrintPrescription="closePrintPrescription" @printSuccess="printSuccess"
          :id="printOrderId" :orderType="'0'" :printType="'1'"></printDialog>
      </div>
    </Card>
  </div>
</template>

<script lang="js">
import { registerList, signCall, registerPay, print, registerRefund, registerRefund1, registerCancel, statusNum } from "@/api/registration"; // 挂号请求
import { isNull,dictText } from '@/utils/validateBase'
import { PAY_WAY } from '@/utils/const'
import { pay, prePay, completeOrder } from '@/api/pricingDetails'
import { getPayRecord, refund } from '@/api/pricingDetails'
import printDialog from '@/components/printDialog'
import { payDTO } from '@/DTO/index'
import { imgArr } from "@/assets/images/img";
export default {
  components: { printDialog },
  data() {
    return {
      loadingImg: imgArr.scan,
      loading: true, // 加载中
      refundLoading:false,
      searchForm: { patientName: null, doctorName: null, phone: null, channel: null, time: null, status: '1' }, // 查询表单
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      pay: false, // 收费状态
      editForm: {}, // 编辑表单数据
      regList: [], // 挂号列表
      allRegList: [], // 挂号列表
      doctorOptions: [], // 医生选项
      options: ['线下', '微信'], // 挂号渠道
      dialogVisible: false,// 收费模态框状态
      dialogPrint: false, // 打印表单状态
      dialogRefund: false, // 退款模态框
      payForm: {}, // 支付表单
      printData: {}, // 打印数据
      refundForm: {}, // 退款数据
      activeIndex: '1', // 激活菜单索引
      deptId: this.$session.get('deptId'), // 医馆id
      menuList: [ // 菜单列表
        { value: 'null', label: '全部订单', number: 0, name: 'all' },
        { value: '0', label: '待支付', number: 0, name: 'stayPay' },
        { value: '1', label: '待签到', number: 0, name: 'staySign' },
        { value: '2', label: '待就诊', number: 0, name: 'staySee' },
        { value: '7', label: '待叫号', number: 0, name: 'cellOrder' },
        { value: '3', label: '已就诊开方', number: 0, name: 'alreadySee' },
        { value: '6', label: '已就诊未开方', number: 0, name: 'visited' },
        { value: '4', label: '已划价', number: 0, name: 'accurately' },
        { value: '-3', label: '已退款', number: 0, name: 'registeredRefund' },
        { value: '-1', label: '已退号', number: 0, name: 'cancel' },
        { value: '-2', label: '停诊', number: 0, name: 'suspendMedical' },
        { value: '-4', label: '跑单', number: 0, name: 'runSingle' },
        { value: '-5', label: '支付超时', number: 0, name: 'runOverTime' },
      ],
      tableHeight: 600, // 表格最大高度
      refreshTimer: null, // 刷新定时器
      payArr: ['现金', '微信', '支付宝', '好码齐'],
      codeVisible: false,
      payLoading: false,
      printOrderId: '',//打印订单id
      printDialogShow: false,
      refundType: '1',//退款方式 1新退款 2老退款
    };
  },
  //监听属性 类似于data概念
  computed: {
    formatNumber() {
      let self = this;
      return function (val) {
        // 对计算属性进行传参
        if (val && val != 0) {
          return self.$toFixed(val);
        } else {
          return 0
        }
      };
    },
  },
  created() {
    if (document.documentElement.clientWidth > 1500) this.tableHeight = document.documentElement.clientHeight - 330;
    else this.tableHeight = document.documentElement.clientHeight - 370;
    this.getRegistersList(); // 获取已挂号列表
    this.getStatusNumber(); // 获取个状态订单数量
    this.$getDoctorOptions({ type: 0, status: 0 }); // 获取医生选项
    this.refreshTimer = setInterval(() => { // 定时刷新订单
      this.getRegistersList();
      this.getStatusNumber();
    }, 5000);
  },
  watch: {
    // 监听searchForm.status变化，如果status==1，定时刷新，否则 不刷新
    searchForm: {
      handler(newVal, oldVal) {
        if (this.searchForm.status == '1') {
          this.refreshTimer = setInterval(() => { // 定时刷新订单
            this.getRegistersList();
            this.getStatusNumber();
          }, 5000);
        } else clearInterval(this.refreshTimer);
      },
      deep: true
    }
  },
  destroyed() {
    clearInterval(this.refreshTimer);
  },
  methods: {
    // 获取挂号列表
    async getRegistersList() {
      let { total, rows, code } = await registerList({ pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm });
      if (code == 200) {
        if (total > 0) {
          rows.forEach(item => {
            this.$session.get('options').forEach(items => {
              if (item.deptId == items.value) item.deptName = items.label
            });
            item.patientName = item.hospPatientInfo.patientName;
            item.sex = item.hospPatientInfo.sex == 0 ? "男" : "女";
            item.phone = item.hospPatientInfo.phone;
            item.status = item.orderInfo.status;
            switch (item.status) {
              case '-5': item.status = "支付超时"; break;
              case '-4': item.status = "跑单"; break;
              case '-3': item.status = "已退款"; break;
              case '-2': item.status = "停诊"; break;
              case '-1': item.status = "已退号"; break;
              case '0': item.status = "待支付"; break;
              case '7': item.status = "待叫号"; break;
              case '6': item.status = "已就诊未开方"; break;
              case '5': item.status = "正在就诊"; break;
              case '4': item.status = "已划价"; break;
              case '3': item.status = "已就诊开方"; break;
              case '2': item.status = "待就诊"; break;
              case '1': item.status = "待签到"; break;
            }
            item.doctorName = item.orderInfo.doctorName;
            if (isNull(item.schedulingTimeInfo)) {
              item.startTime = ''
              item.timeName = ''
            } else {
              item.startTime = this.$computeTime(item.schedulingTimeInfo.startTime);
              item.timeName = item.schedulingTimeInfo.timeName + " " + item.registeredCode + " 号";
            }
          });
        }
        this.regList = rows;
        this.total = total;
      }
      this.loading = false;
    },
    // 获取订单状态数量
    async getStatusNumber() {
      let { code, data } = await statusNum(this.searchForm);
      if (code == 200) {
        this.menuList.forEach(item => {
          for (let key in data) {
            if (item.name == key) item.number = data[key]
          }
        })
      }
    },
    // 切换菜单
    changeStatus() {
      if (this.activeIndex == 'null') this.searchForm.status = null;
      else this.searchForm.status = this.activeIndex;
      this.$refresh(this.getRegistersList);
    },
    // 获取打印数据
    async toPrint(row) {
      this.printOrderId = row.orderInfo.orderId
      let { data, code } = await print(row.registeredId);
      if (code == 200) {
        data.startTime = this.$computeTime(data.startTime);
        data.stopTime = this.$computeTime(data.stopTime);
        this.$computeAge(data.birthday, data);
        this.printData = data;
        let phone = this.printData.patientPhone;
        if (phone) this.printData.patientPhone = phone.substr(0, 3) + '****' + phone.substr(7);
        this.dialogPrint = true;
      }
    },
    // 打印
    print() {
      this.printDialogShow = true
    },
    // 签到
    async sign(row) {
      let { code } = await signCall({ registeredId : row.registeredId });
      if (code == 200) this.$message.success("签到叫号成功！");

      this.$refresh([this.getRegistersList, this.getStatusNumber]);
    },
    // 取消挂号
    async returnNum(registeredId) {
      let { code } = await registerCancel(registeredId);
      if (code == 200) this.$message.success("取消挂号成功！");
      this.$refresh(this.getRegistersList, this.getStatusNumber);
    },
    // 去退款
    toRefund(row) {
      this.refundForm = {
        deptId: this.$session.get('deptId'),
        refundAmount: row.realPay, registeredId: row.registeredId, remark: null,
        refundWayStr: '原路返回', type: row.type, channel: row.channel
      }
      if (row.payWay == '线上微信') {
        this.refundType = '2'

      } else {
        this.refundType = '1'
        getPayRecord({ orderNumber: row.orderCombinedNum }).then(res => {
          if (res.code == 200) {
            let record = res.data.filter(item => {
              return item.paySuccess == '1'
            })
            let { orderNumber, orderPayNumber, payPalNumber, payWay } = record[0]
            this.refundForm.orderNumber = orderNumber
            this.refundForm.orderPayNumber = orderPayNumber
            this.refundForm.payPalNumber = payPalNumber
            this.refundForm.refundWay = payWay
          }
        })
      }
      this.dialogRefund = true
    },
    // 退款
    isRefund() {
      this.$refs['refundForm'].validate((valid) => {
        let msg = '';
        if (this.refundForm.refundWay == '直接退现金') msg = '点击继续退款，直接退现金给患者';
        else msg = '点击继续退款,微信线上支付金额原路退回, 子商户将自动退款';
        if (valid) {
          this.$confirm(msg).then(_ => {
            this.refundLoading=true
            if (this.refundType == '1') {
              payDTO.refundFun(this.refundForm, this.refundForm).then(refundRes => {
                if (refundRes.code == 200) {
                  registerRefund(this.refundForm).then(res => {
                    if (res.code == 200) {
                      this.$message.success("退款退号成功！");
                      this.refundLoading=false
                      this.dialogRefund = false;
                      this.$refresh([this.getRegistersList, this.getStatusNumber]);
                      this.$refs['refundForm'].resetFields();

                    }else{
                      this.refundLoading = false
                    }
                  })
                }
              }).catch(err=>{
                 this.refundLoading = false
              })
            } else {
              registerRefund1(this.refundForm.registeredId).then(res => {
                if (res.code == 200) this.$message.success("退款退号成功！");
                this.dialogRefund = false;
                this.refundLoading = false
                this.$refresh([this.getRegistersList, this.getStatusNumber]);
                this.$refs['refundForm'].resetFields();
              })
            }
          }).catch(_ => { });
        } else return false;
      });
    },
    // 设置支付方式
    payWay(val) {
      this.payForm.payWay = val;
    },
    // 去收费
    toCharge(row) {
      this.dialogVisible = true;
      this.payForm = {};
      this.payForm.price = row.price;
      this.payForm.realPay = row.price;
      this.payForm.copeWithPay = row.price;
      this.payForm.orderNumber = row.orderNumber;
      this.payForm.registeredId = row.registeredId;
      this.payForm.ctOrderId = row.ctOrderId;
    },
    // 收费完成
    async charge() {
      if (this.payForm.payWay == null) this.$message.error("未选择收费方式！");
      else {
        if (this.payForm.payWay == '好码齐') {
          this.codeVisible = true;
          this.$refs['codeInput'].focus();
        } else {
          this.chargeRequest();
        }
      }
    },
    // 获取扫码code
    getCode(value) {
      this.payForm.payQrCode = ''
      this.payForm.payQrCode = value;
      if (!!value) {
        this.$message.success('扫码成功！')
        this.codeVisible = false;
        setTimeout(() => {
          this.chargeRequest()
        }, 100)
      }
    },
    async chargeRequest() {
      this.payLoading = true
      let { payWay, payQrCode, realPay, orderNumber, ctOrderId } = this.payForm
      let payPramas = {
        payAmount: realPay,
        payWay: this.handlePayStr(payWay),
        payee: this.$session.get('user').nickName,
        userAuthCode: payQrCode,
        deptId: this.$session.get('deptId'),
      }
      let ctOrderIds = []
      ctOrderIds[0] = ctOrderId
      let preParams = {
        amount: realPay,
        ctOrderIds: ctOrderIds,
        payWay: this.handlePayStr(payWay),
        deptId: this.$session.get('deptId'),
      }
      payDTO.payFun(preParams, payPramas).then(async res => {
        let { code, data, orderNumber } = res
        if (code == 200) {
          completeOrder({ ctOrderIds: ctOrderIds }).then(res => {
            if (res.code == 200) {
              this.$message.success("收费成功！");
              this.dialogVisible = false;
              this.$refresh(this.getRegistersList);
              this.payLoading = false
            } else {
              this.payLoading = false
            }
          })
        } else {
          this.payLoading = false
        }
      })
    },
    /**
   *  处理支付方式
   * @param {*} timeRange 
   * @param {*} date 
   */
    handlePayStr(val) {
      let value = ''
      PAY_WAY.forEach(item => {
        if (item.label == val) {
          value = item.value
        }
      })
      return value
    },
    /**
     * 打印完成
     */
    printSuccess() {
      this.printDialogShow = false;
      this.dialogPrint = false
    },
    /**
   * 取消打印
   */
    closePrintPrescription() {
      this.printDialogShow = false
    },
    /**
     * 支付方式格式化
     */
    payWayFormatter(row){
      return dictText(row.payWay,PAY_WAY)
    }
  },
};
</script>

<style lang="less" scoped>
.charge {
  text-align: center;
  font-size: 30px;
  margin-bottom: 30px;
}

.chargeBtn {
  width: 100px;
  margin-bottom: 10px;

  &:nth-of-type(4) {
    margin-left: 0;
  }
}

.hide-section {
  opacity: 0;
}

.circle {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgb(83, 83, 83);
}

.size18 {
  font-size: 18px;
}

.center {
  text-align: center;
}

.flex {
  display: flex;
}

.jc_ce {
  justify-content: center;
}

.al_ce {
  align-items: center;
}

.marginT30 {
  margin-top: 30px;
}

.marginL5 {
  margin-left: 5px;
}

.marginR5 {
  margin-right: 5px;
}

.load .circle:nth-last-child(1) {
  animation: move 0.8s 0.1s linear infinite;
}

.load .circle:nth-last-child(2) {
  animation: move 0.8s 0.2s linear infinite;
}

.load .circle:nth-last-child(3) {
  animation: move 0.8s 0.3s linear infinite;
}

@keyframes move {
  0% {
    transform: translate(0, -5px);
  }

  50% {
    transform: translate(0, 5px);
  }

  100% {
    transform: translate(0, -5px);
  }
}
</style>